export * from "./news/News"
export * from "./articles/Articles"
export * from "./downloads/Downloads"
export * from "./magazine/Magazine"
export * from "./searchPharmacy/SearchPharmacy"
export * from "./jobOffers/JobOffers"
export * from "./prixMinus/PrixMinusMap"
export * from "./employees/Employees"
export * from "./callToAction/CallToAction"
export * from "./columns/Columns"
export * from "./content/Content"
export * from "./contentWithImage/ContentWithImage"
export * from "./gallery/Gallery"
export * from "./hero/Hero"
export * from "./image/Image"
export * from "./logoGrid/LogoGrid"
export * from "./pageHeader/PageHeader"
export * from "./teasers/Teasers"
export * from "./video/Video"
export * from "./form/Form"
export * from "./timeline/Timeline"
export * from "./cartePlus/CartePlus"
